import {HostBinding, ElementRef,QueryList,ViewChild,ViewChildren,Component, OnInit, OnChanges, OnDestroy ,SimpleChanges, AfterViewInit,ViewEncapsulation, Input, Output, EventEmitter} from '@angular/core';
import {Subscription} from 'rxjs'
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {ArticleService} from '../../services/article.service';
import {NewsletterService} from '../../services/newsletter.service';
import {CommonService} from '../../services/common.service';
import {DomSanitizer} from '@angular/platform-browser';
import { CommentreplyComponent } from '../commentreply/commentreply.component';
//import { GoogleTagManagerService } from 'angular-google-tag-manager';
declare var $:any;
import * as moment from 'moment';
let date = moment().format('MMM Do,YYYY');

@Component({
  selector: 'app-view-article',
  templateUrl: './view-article.component.html',
  styleUrls: ['./view-article.component.css'],
  encapsulation:ViewEncapsulation.None,
})
export class ViewArticleComponent  extends BaseComponent implements OnInit ,OnDestroy {

  @HostBinding('style.width') public width: string = '100%';

  // @ViewChildren(CommentreplyComponent) commentmessage !: QueryList<CommentreplyComponent>;

  latestComments:any=[];
  isAdmin:boolean=false;
  articleId:any;
  newsletterId:any;
  source:any;
  authorId:any;
  toastr:any;
  url:any=AppSettings.API_ENDPOINT
  loginUser:any;
  headerImage:any;
  headerImageName:any;
  thumbImage:any;
  thumbImageName:any;
  attachment:Array<any>=[];
  attachmentName:Array<any>=[];
  toltipName:Array<any>=[];

  attachmentGoTO:Array<any>=[];
    attachmentNameGoTo:Array<any>=[];
    toltipNameGoTo:Array<any>=[]
    totalFiles:number;

  tittle:string;
  subTittle:string;
  htmlContent:any='';
  htmlDescription:string='';
  tags:Array<string>=[];
  user:any;
  userId:any;
  date:string=date;
  link:any;
  router:any;
  msg:any;
  userName='';
  navigationsType=[];
  createdby:any;
  department:any;
  createdDate:any;
  sharedList:any;
  sharedList1:any;

  comments:any;
  commentAttachmentName=[];
  commentToltipName=[];
  commentAttachment=[];

  commentList:Array<any>=[];
  commentDocument:any;
  commentedUserName:any;
  issubmit:boolean=false
  commonService:any;
  dropdownSettings={};

  selectedReply:any='';
  selectedType:any=[];

  permissions:any=[];

  author:any='';

  token:any;
  articleStatus:any;
  offset:number = 0;
  deletecommentId:any;
  deleteReplyId:any;

  userRole:Array<any>=[];

  record:any;
  commentId:any;
  asset_path:string= AppSettings.API_ENDPOINT;
  dataList:any =[
    {'key':'private','value':'Private'},
    {'key':'public','value':'Public'}
  ];

  searchTxt:any ='';
  notification:any=[];
  category:any;
  type:any;
  text:any;
  redirected_from:string='';
  prevsource:any;

  subscription:Subscription;
  latest_articles:any=[];
  loader_image:boolean =true
  showLoadMore:boolean=true;

  countributorArticleId:any;
  showContributorLoadMore:boolean=true
  latestContributor:any=[]
  isShow:boolean=false
  
  currentUser:any

  constructor(private domSanitizer:DomSanitizer, cmmonService:CommonService,private articleService:ArticleService,msg:MessageService, toastr: ToastrService,homeservice:HomeService,_router: Router,private route:ActivatedRoute,private newsService:NewsletterService) {




    super(msg,toastr,homeservice,_router);

    this.commonService=cmmonService;
    this.toastr = toastr;
    this.router = _router;
    this.msg = msg;


    this.route.queryParams.subscribe(params =>{

      if(params.search!=undefined){

        this.searchTxt = params.search;

      }
      if(params.id!=undefined){
        this.newsletterId = params.id;
      }
      if(params.source!=undefined){
        this.source = params.source;

      
      }

      if(params.comment!=undefined){
        this.commentId = params.comment;
      }

      if(params.category!=undefined){
        this.category = params.category
      }
      if(params.type!=undefined){
        this.type = params.type;
      }

      if(params.prevsource!=undefined || params.prevsource!=''){
        this.prevsource = params.prevsource
      }else{
        this.prevsource = 'newsletter'
      }


    })

    this.route.params.subscribe(
      params => {
        this.articleId = params['id'];
        this.redirected_from = 'article-'+this.articleId
        this.getArticle(this.articleId)

      })

    try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

        if(!tokenA) throw 'Error in parse';

        if(!JSON.parse(tokenA)) throw 'Error in json parse';

        tokenA = JSON.parse(tokenA);

        this.token = tokenA.token

        this.articleService.articleData({token:tokenA.token,'page':'similar',similar:this.articleId,limit:10}).subscribe( (res) =>{
    
          if(res.status=='success'){
  
            this.latest_articles = res.article;
            setTimeout(() => {
              $('#related-article').owlCarousel({
                loop:true,
                margin:15,
                items:4,
              autoplay:false,
                nav:true,
              dots:false,
               responsiveClass: true,
                responsive: {
                    0:{
                      items: 1
                    },
                    480:{
                      items: 1
                    },
                    769:{
                      items: 2
                    },
                1024:{
                      items: 4
                    }
                }
              })
            }, 100);
           
          }
  
        });

        let data={
          article:this.articleId,
          event:'avstart',
          source:'web',
          token:this.token
        }
        this.articleService.analytics(data).subscribe( (res)=>{
    
          if(res.status=='success' ){
    
          }
        })


    } catch(exec){
      toastr.error('Article Not Found  !', '', {timeOut: 3000});
    }

  }

  getArticle(articleId){
   
    try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

        if(!tokenA) throw 'Error in parse';

        if(!JSON.parse(tokenA)) throw 'Error in json parse';

        tokenA = JSON.parse(tokenA);

        this.token = tokenA.token

       
        if(articleId){

          this.link = '/article/'+this.articleId+'/edit';
          let data2={
            token:tokenA.token,
            id:articleId,
            'page':'article',
            'source':this.source
          }

          this.articleService.articleData(data2).subscribe( (response)=>{

            this.loader_image=false

            this.loginUser= response.user;

            this.userRole =response.permission;

            this.userId = response.user.id
            this.currentUser=response.user

            // this.isAdmin =this.userRole.includes('manage_article');
            this.isAdmin = this.userRole.indexOf('manage_article')>=0?true:false;

            this.userName=response.user.name;

            this.record = response.article[0];

            if(response.article[0].status=='Published'){
                this.text = 'Published on '
                this.createdDate = response.article[0].history.updatedDate
            }else{
                this.text = 'Last edited on '
                this.createdDate = response.article[0].history.updatedDate
            }

          

            this.navigationsType=response.navigation;

            this.notification = response.notification;

            this.permissions = (response.permission !=undefined || response.permission!=null)? response.permission:[];

            
            if(this.record.country){
              let exist=this.record.country.indexOf(this.currentUser['country'])
              let emailExits=this.currentUser['email'].indexOf('@mitsubishi-motors-euro.com')
             
              if(exist!=-1 || emailExits!=-1){
                this.isShow=true
              }else{
                this.isShow=false
              }

             
              
            }else{
              this.isShow=true
            }
           


            let per =  ((this.check_permission_admin(this.record,this.loginUser) ||  this.check_permission_only_publisher(this.record,this.loginUser) || this.check_permission_only_author(this.record,this.loginUser) || this.check_permission_only_reviewer(this.record,this.loginUser) || this.check_permission_only_coauthor(this.record,this.loginUser) || this.check_permission_only_contributor(this.record,this.loginUser) ) ||  (this.record.status=='Published' && this.isShow==true) );



            this.broadcast_menu();


            if(per==false){


              this.toastr.error(' You dont have the permission to view the article  !', '', {timeOut: 3000});

              this.router.navigate(['/article']);

            }



            if(response.status=='success'){

              this.author=response.article[0].history.createdBy;

              this.articleStatus = response.article[0].status;
              this.tittle = response.article[0].title;
              this.subTittle = response.article[0].subtitle;
              this.sharedList = response.article[0].contributors;
              this.sharedList1 = response.article[0].coauthors;
              this.htmlDescription = response.article[0].summary;
              this.htmlContent = this.domSanitizer.bypassSecurityTrustHtml(response.article[0].content);
              if(response.article[0].department!=undefined){
                this.department =response.article[0].department
              }else if(response.article[0].history.createdBy!=undefined){
                this.createdby = response.article[0].history.createdBy
              }
              // this.createdby = response.article[0].history.createdBy
              

              if(response.article[0].mainimage){
                let name = response.article[0].mainimage.split('/');
                this.headerImageName = name[2] ;
              }

              if(response.article[0].thumbimage){
                let tname = response.article[0].thumbimage.split('/');
                this.thumbImageName = tname[2];
              }

              this.headerImage = response.article[0].mainimage ;
              this.thumbImage = response.article[0].thumbimage;

              response.article[0].document.map((x)=>{
                console.log("view====",x);

                if(x.includes("mitsubishi-motors")){
                  try{

                    let token: any = JSON.parse(atob(localStorage.getItem('token')));
                    var data = new FormData();
                    data.append('upload[0][url]',x);
            
                    let obj={
                      token:token,
                      reqData:data
                    }
            
                    this.newsService.imageUpload(obj).subscribe( (res) =>{
                      console.log("ress----",res);

                      if(res.status=='success'){
                             this.attachmentNameGoTo.push(decodeURIComponent(res.files[0].info['Content-Disposition']['filename']))
                             this.attachmentGoTO.push(x)
                            //  let toltip = res.files[0].info['Content-Disposition']['filename'];
                            //  toltip.shift();
                            //  let arr=[]
                            //  toltip.map((y)=>{
                            //   console.log("y----",y);
                            //    arr.push(decodeURIComponent(y))
                            //  })
                             this.toltipNameGoTo.push(decodeURIComponent(res.files[0].info['Content-Disposition']['filename']))

                             this.totalFiles = this.attachment.length + this.attachmentGoTO.length;

                      }

                    })
                  }
                  catch(e){
                    this.toastr.error('File upload failed!', '', {timeOut: 3000});
                  }
                }else{
                  let name = x.split('/');
                  let toltip = name[2].split('_');
                  toltip.shift();
                  let arr=[]

                  toltip.map((y)=>{
                    arr.push(y)
                  })

                  this.toltipName.push(arr.join('_'))
                  this.attachmentName.push(name[2])
                  this.attachment.push(x)
                  this.totalFiles = this.attachment.length;
                }
                  

              })
                console.log("fl--1", this.attachment.length)
                console.log("fl--2", this.attachmentGoTO.length)

                
              //this.totalFiles = this.attachment.length + this.attachmentGoTO.length;

              this.tags = response.article[0].tag;

              this.user = response.article[0].history.createdBy;


              this.authorId = response.article[0].history.createdId;

              this.date = response.article[0].history.createdDate
              // this.date = moment(response.article[0].history.createdDate).format('MMM Do,YYYY');
                 
              let data = this.source.split('-')

            this.msg.sendMessage({type:'customeEvent',event:'article',value:this.tittle,source:data[0],articleId:this.articleId});


            }else{
              this.toastr.error('Article Not Found  !', '', {timeOut: 3000});
            }

          })

          let data3={
            token:tokenA.token,
            article:articleId
          }
          this.articleService.commentSave(data3).subscribe( (res)=>{

            if (res.status == 'success') {

             this.commentList = res.comment;

             this.offset = this.commentList.length;



             this.commentList.map((x,i)=>{

                if(x.commentAttachments){
                  x['commentAttachmentsName']=[]
                  x['title']=[]
                  x['toltipName']=[]
                  x.commentAttachments.map((y)=>{
                    let name=y.split('.').slice(1)
                    let title = y.split('/').slice(2)
                    let toltip = title[0].split('_');
                    toltip.shift();
                    let arr=[]
                    toltip.map((y)=>{
                      arr.push(y)
                    })
                    x.toltipName.push(arr.join('_'))
                    x.commentAttachmentsName.push(name[0])
                    x.title.push(title[0])
                  })
                }

                x.editMode = false;
                x.replyMode = false;
                if(x.commentReply){
                  x.commentReply.map((y)=>{
                    y.editMode = false;

                    if(y.commentAttachments){
                      y['commentAttachmentsName']=[]
                      y['title']=[]
                      y['toltipName']=[]
                      y.commentAttachments.map((z)=>{
                        let name=z.split('.').slice(1)
                        let title = z.split('/').slice(2)
                        y.commentAttachmentsName.push(name[0])
                        y.title.push(title[0])
                        let toltip = title[0].split('_');
                        toltip.shift();
                        let arr=[]
                        toltip.map((k)=>{
                          arr.push(k)
                        })
                        y.toltipName.push(arr.join('_'))
                      })
                    }

                  })
                }
                if(x.status =='Private'){
                  this.selectedType[i] = [{'key':'private','value':'Private'}]
                }else{
                  this.selectedType[i] = [{'key':'public','value':'Public'}]
                }

             })



            }else{
              this.toastr.error('Comment Not Founds  !', '', {timeOut: 3000});
            }

          })

        }

        if(articleId && this.newsletterId){

          let data={
            token:tokenA.token,
            article:articleId,
            newsletter:this.newsletterId
          }

          if(this.source!=undefined){
            data['source'] = this.source
          }

          // this.articleService.tracking(data).subscribe( (res)=>{

          // })

        }

        this.showLoadMore = true
        
        this.articleService.articleStatus({'token':this.token,'reqData':{'article':articleId,'offset':0}}).subscribe( (result)=>{



          if(result.status=='success'){


           this.latestComments= result.workflow;

          } else{

           this.latestComments= [];


          }

         });
      


    } catch(exec){
      this.toastr.error('Article Not Found  !', '', {timeOut: 3000});
    }
  }

  broadcast_menu(){

    this.msg.sendMessage({'user':this.userName,'type':'left_menu_link','navigations':this.navigationsType,'notification':this.notification,currentPage:'article'});

  }




  

  uploadAttachment($event){
    this.processAttachment($event.target.files);
  }

  processAttachment(files){

    var formData = files;
    var data = new FormData();

    let toastr = this.toastr

    $.each(formData, function(i, file) {

     let ext = file.name.split('.').pop();


     if(ext=="pdf" || ext=="docx" || ext=="doc" || ext=="xls" || ext=="xlsx" || ext=="csv" || ext=="ppt" || ext=="pptx"){

      data.append('file'[i], file);

     }else{

      toastr.warning('Please choose pdf,doc,docx,xls,xlsx or csv file !', '', {timeOut: 3000});
     }

    });


    try{
      let token: any = JSON.parse(atob(localStorage.getItem('token')));
      let obj = {
          token: token,
          reqData: data
      }
      this.newsService.imageUpload(obj).subscribe((res) => {

          if (res.status == 'success') {
            // this.commentAttachmentName=[]
            // this.commentAttachment=[]
            res.files.map((x)=>{
               let name = x.path.split('/');
               this.commentAttachmentName.push(name[2])
               this.commentAttachment.push(x.path)
               let toltip = name[2].split('_');
                 toltip.shift();
                 let arr=[]

                 toltip.map((y)=>{
                   arr.push(y)
                 })

                 this.commentToltipName.push(arr.join('_'))
            })

          } else {
            this.toastr.error('File upload failed!', '', {timeOut: 3000});
          }

      })
    }catch(exec){
      this.toastr.error('File upload failed!', '', {timeOut: 3000});
    }
  }

  deleteAttachment(index){

    this.commentAttachmentName.splice(index, 1)
    this.commentAttachment.splice(index, 1)
    this.commentToltipName.splice(index, 1)

  }

  saveComment(){

     this.issubmit=true

    if(this.comments){

      try{

        let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

          if(!tokenA) throw 'Error in parse';

          if(!JSON.parse(tokenA)) throw 'Error in json parse';

          tokenA = JSON.parse(tokenA);

          let data={
            token:tokenA.token,
            article:this.articleId,
            comments:this.comments,
            commentAttachments:this.commentAttachment,
            commentReply : 'X'
          }
          this.articleService.commentSave(data).subscribe( (res)=>{

            if (res.status == 'success') {
              this.comments = ''
              this.commentAttachment = []

              this.toastr.success('Comment Saved Sucessfully  !', '', {timeOut: 3000});

              let data3={
                token:tokenA.token,
                article:this.articleId
              }
              this.articleService.commentSave(data3).subscribe( (res)=>{

                if (res.status == 'success') {
                  this.issubmit=false
                  this.commentList = res.comment;
                  this.offset = this.commentList.length;
                  this.commentList.map((x,i)=>{

                    if(x.commentAttachments){
                      if(!x.commentAttachmentsName){
                        x['commentAttachmentsName']=[]
                      }
                      x['title']=[]
                      x['toltipName']=[]
                      x.commentAttachments.map((y)=>{

                        let name=y.split('.').slice(1)
                        x.commentAttachmentsName.push(name[0])
                        let title = y.split('/').slice(2)
                         x.title.push(title[0])
                         let toltip = title[0].split('_');
                         toltip.shift();
                         let arr=[]
                         toltip.map((y)=>{
                           arr.push(y)
                         })
                         x.toltipName.push(arr.join('_'))
                      })
                    }
                    if(x.commentReply){
                      x.commentReply.map((y)=>{
                        y.editMode = false;

                        if(y.commentAttachments){
                          y['commentAttachmentsName']=[]
                          y['title']=[]
                          y['toltipName']=[]
                          y.commentAttachments.map((z)=>{
                            let name=z.split('.').slice(1)
                            y.commentAttachmentsName.push(name[0])
                            let title = z.split('/').slice(2)
                            y.title.push(title[0])
                            let toltip = title[0].split('_');
                            toltip.shift();
                            let arr=[]
                            toltip.map((k)=>{
                              arr.push(k)
                            })
                            y.toltipName.push(arr.join('_'))
                          })
                        }

                      })
                    }
                    if(x.status =='Private'){
                      this.selectedType[i] = [{'key':'private','value':'Private'}]
                    }else{
                      this.selectedType[i] = [{'key':'public','value':'Public'}]
                    }
                 })

                }else{
                  this.toastr.error('Comment Not Founds  !', '', {timeOut: 3000});
                }

              })

            }else{
              this.toastr.error('Comment Not Saved  !', '', {timeOut: 3000});
            }

          })


        } catch(exec){

          this.toastr.error('Comment Not Saved  !', '', {timeOut: 3000});
        }
    }


  }

  deleteComment(){

    let data={
      token:this.token,
      article:this.articleId,
      id:this.deletecommentId,
      archive:true
    }
    this.articleService.commentSave(data).subscribe( (res)=>{

      if (res.status == 'success') {

        let data3={
          token:this.token,
          article:this.articleId
        }
        this.articleService.commentSave(data3).subscribe( (res)=>{

          if (res.status == 'success') {

            this.commentList = res.comment;
            this.offset = this.commentList.length;
            this.commentList.map((x,i)=>{

               if(x.commentAttachments){
                 x['commentAttachmentsName']=[]
                 x['title']=[]
                 x['toltipName']=[]
                 x.commentAttachments.map((y)=>{
                   let name=y.split('.').slice(1)
                   x.commentAttachmentsName.push(name[0])
                   let title = y.split('/').slice(2)
                   x.title.push(title[0])
                   let toltip = title[0].split('_');
                    toltip.shift();
                    let arr=[]
                    toltip.map((y)=>{
                      arr.push(y)
                    })
                    x.toltipName.push(arr.join('_'))
                 })
               }
               if(x.commentReply){
                x.commentReply.map((y)=>{
                  y.editMode = false;

                  if(y.commentAttachments){
                    y['commentAttachmentsName']=[]
                    y['title']=[]
                    y['toltipName']=[]
                    y.commentAttachments.map((z)=>{
                      let name=z.split('.').slice(1)
                      y.commentAttachmentsName.push(name[0])
                      let title = z.split('/').slice(2)
                      y.title.push(title[0])
                      let toltip = title[0].split('_');
                    toltip.shift();
                    let arr=[]
                    toltip.map((k)=>{
                      arr.push(k)
                    })
                    y.toltipName.push(arr.join('_'))
                    })
                  }

                })
              }
              if(x.status =='Private'){
                this.selectedType[i] = [{'key':'private','value':'Private'}]
              }else{
                this.selectedType[i] = [{'key':'public','value':'Public'}]
              }

            })
          }
        });

      }

    })


  }


  editMode(indx:any){

    this.commentList[indx].editMode = true

  }

  cancelEdit(indx:any){

    this.commentList[indx].editMode = false

  }

  uploadEditAttachment($event,indx){

    var formData = $event.target.files;
    var data = new FormData();

    $.each(formData, function(i, file) {

     let ext = file.name.split('.').pop();


     if(ext=="pdf" || ext=="docx" || ext=="doc" || ext=="xls" || ext=="xlsx" || ext=="csv"){

      data.append('file'[i], file);

     }else{
      this.toastr.warning('Please choose pdf,doc,docx,xls,xlsx or csv file !', '', {timeOut: 3000});
     }

    });


    try{
      let token: any = JSON.parse(atob(localStorage.getItem('token')));
      let obj = {
          token: token,
          reqData: data
      }
      this.newsService.imageUpload(obj).subscribe((res) => {

          if (res.status == 'success') {

            res.files.map((x)=>{
               let name = x.path.split('/');
               let y = name[2].split('.');

               if(!this.commentList[indx].commentAttachmentsName){
                this.commentList[indx]['commentAttachmentsName']=[]
               }
               if(!this.commentList[indx].commentAttachments){
                this.commentList[indx]['commentAttachments']=[]
               }
               if(!this.commentList[indx].title){
                this.commentList[indx]['title']=[]
               }

               if(!this.commentList[indx].toltipName){
                this.commentList[indx]['toltipName']=[]
               }

               this.commentList[indx].commentAttachmentsName.push(y[1])
               this.commentList[indx].commentAttachments.push(x.path)
               this.commentList[indx].title.push(name[2])
               let toltip = name[2].split('_');
               toltip.shift();
               let arr=[]
               toltip.map((y)=>{
                 arr.push(y)
               })

               this.commentList[indx].toltipName.push(arr.join('_'))
            })



          } else {
            this.toastr.error('File upload failed!', '', {timeOut: 3000});
          }

      })
    }catch(exec){
      this.toastr.error('File upload failed!', '', {timeOut: 3000});
    }

  }

  deleteCommentAttachment(indx,index){

    this.commentList[indx].commentAttachmentsName.splice(index, 1)
    this.commentList[indx].commentAttachments.splice(index, 1)
    this.commentList[indx].title.splice(index, 1)
    this.commentList[indx].toltipName.splice(index, 1)

  }

  saveEdit(indx:any){

    let status={}



    let data={
      token:this.token,
      article:this.articleId,
      id:this.commentList[indx].id,
      comments:this.commentList[indx].comments,
      commentAttachments:this.commentList[indx].commentAttachments,
      commentReply:'X'

    }

    if(this.selectedType[indx][0].key=='public'){
      data['public'] =true
    }

    this.articleService.commentSave(data).subscribe( (res)=>{

      if (res.status == 'success') {

        this.commentList[indx].editMode = false

        this.toastr.success('Comment Saved Sucessfully  !', '', {timeOut: 3000});

        let data3={
          token:this.token,
          article:this.articleId
        }
        this.articleService.commentSave(data3).subscribe( (res)=>{

          if (res.status == 'success') {
            this.issubmit=false
            this.commentList = res.comment;
            this.offset = this.commentList.length;
            this.commentList.map((x,i)=>{

              if(x.commentAttachments){
                x['title']=[]
                x['toltipName']=[]
                if(!x.commentAttachmentsName){
                  x['commentAttachmentsName']=[]
                }
                x.commentAttachments.map((y)=>{

                  let name=y.split('.').slice(1)
                  x.commentAttachmentsName.push(name[0])
                  let title = y.split('/').slice(2)
                   x.title.push(title[0])
                   let toltip = title[0].split('_');
                    toltip.shift();
                    let arr=[]
                    toltip.map((y)=>{
                      arr.push(y)
                    })
                    x.toltipName.push(arr.join('_'))
                })
              }
              if(x.commentReply){
                x.commentReply.map((y)=>{
                  y.editMode = false;

                  if(y.commentAttachments){
                    y['title']=[]
                    y['toltipName']=[]
                    y['commentAttachmentsName']=[]
                    y.commentAttachments.map((z)=>{
                      let name=z.split('.').slice(1)
                      y.commentAttachmentsName.push(name[0])
                      let title = z.split('/').slice(2)
                      y.title.push(title[0])
                      let toltip = title[0].split('_');
                      toltip.shift();
                      let arr=[]
                      toltip.map((k)=>{
                        arr.push(k)
                      })
                      y.toltipName.push(arr.join('_'))
                    })
                  }

                })
              }
              if(x.status =='Private'){
                this.selectedType[i] = [{'key':'private','value':'Private'}]
              }else{
                this.selectedType[i] = [{'key':'public','value':'Public'}]
              }
           })

          }else{
            this.toastr.error('Comment Not Founds  !', '', {timeOut: 3000});
          }

        })

      }else{
        this.toastr.error('Comment Not Saved  !', '', {timeOut: 3000});
      }

    })

  }

  replyMode(indx:any){

    this.commentList[indx].replyMode = true

  }

  cancelReply(indx:any){

    this.commentList[indx].replyMode = false

  }

  replyEditMode(i,k){

    this.commentList[i].commentReply[k].editMode = true
  }

  cancelEditReply(i,k){
    this.commentList[i].commentReply[k].editMode = false
  }

  replySubmitted($event,indx){


    if($event == true){

      this.commentList[indx].replyMode = false;

      let data3={
        token:this.token,
        article:this.articleId
      }
      this.articleService.commentSave(data3).subscribe( (res)=>{

        if (res.status == 'success') {
          this.issubmit=false
          this.commentList = res.comment;
          this.offset = this.commentList.length;
          this.commentList.map((x,i)=>{

            if(x.commentAttachments){
              x['title']=[]
              x['toltipName']=[]
              if(!x.commentAttachmentsName){
                x['commentAttachmentsName']=[]
              }
              x.commentAttachments.map((y)=>{

                let name=y.split('.').slice(1)
                x.commentAttachmentsName.push(name[0])
                let title = y.split('/').slice(2)
                x.title.push(title[0])
                let toltip = title[0].split('_');
                    toltip.shift();
                    let arr=[]
                    toltip.map((y)=>{
                      arr.push(y)
                    })
                    x.toltipName.push(arr.join('_'))
              })
            }
            if(x.commentReply){
              x.commentReply.map((y)=>{
                y.editMode = false;

                if(y.commentAttachments){
                  y['title']=[]
                  y['toltipName']=[]
                  y['commentAttachmentsName']=[]
                  y.commentAttachments.map((z)=>{
                    let name=z.split('.').slice(1)
                    y.commentAttachmentsName.push(name[0])
                    let title = z.split('/').slice(2)
                     y.title.push(title[0])

                     let toltip = title[0].split('_');
                    toltip.shift();
                    let arr=[]
                    toltip.map((k)=>{
                      arr.push(k)
                    })
                    y.toltipName.push(arr.join('_'))
                  })
                }

              })
            }
            if(x.status =='Private'){
              this.selectedType[i] = [{'key':'private','value':'Private'}]
            }else{
              this.selectedType[i] = [{'key':'public','value':'Public'}]
            }
         })

        }else{
          this.toastr.error('Comment Not Founds  !', '', {timeOut: 3000});
        }

      })


    }



  }

  onTypeSelect(event:any,indx:any){

     this.selectedType[indx] = [event]

  }


  check_permission_only_publisher(article,user){

    if(article!=undefined){
    let publisher = (article.publisher !=undefined)?article.publisher:[];


    //  return  publisher.includes(user.id) ;

    // return ( publisher.join().indexOf(user.id) >= 0)?true:false
      let ispermission =false

      publisher.map((x)=>{
        if(x==user.id){
          ispermission=true
        }
      })
      
      return ispermission
    }


   }

   check_permission_only_reviewer(article,user){

    if(article!=undefined){
    let approver = (article.approver !=undefined)?article.approver:[];

    // return approver.includes(user.id);

    //  return ( approver.join().indexOf(user.id) >= 0)?true:false
      let ispermission =false

      approver.map((x)=>{
        if(x==user.id){
          ispermission=true
        }
      })
      
      return ispermission
    }

   }


   check_permission_only_coauthor(article,user){

    if(article!=undefined){
    let coauthor = (article.coauthor !=undefined)?article.coauthor:[];

    // return approver.includes(user.id);

    //  return ( coauthor.join().indexOf(user.id) >= 0)?true:false
      let ispermission =false

      coauthor.map((x)=>{
        if(x==user.id){
          ispermission=true
        }
      })
      return ispermission
    }

   }

   check_permission_only_contributor(article,user){

    if(article!=undefined){
    let contributor = (article.contributor !=undefined)?article.contributor:[];

    // return approver.includes(user.id);

    //  return ( contributor.join().indexOf(user.id) >= 0)?true:false
        let ispermission =false

        contributor.map((x)=>{
          if(x==user.id){
            ispermission=true
          }
        })
        return ispermission
    }

   }

   check_permission_only_author(article,user){

    if(article!=undefined){
      let author = (article.author !=undefined)?article.author:[];

      // return  ((article.history.createdId == user.id) || (( author.join().indexOf(user.id) >= 0)?true:false));
      let ispermission =false

      author.map((x)=>{
        if(x==user.id){
          ispermission=true
        }
      })
      
      return ((article.history.createdId == user.id) || ispermission)
    }

   }



  check_permission_author(article,user){


    if(article!=undefined){
      
      let author = (article.author !=undefined)?article.author:[];

      // return (article.status =='Draft' || article.status =='Rejected') && ( article.history.createdId == user.id || ((author.join().indexOf(user.id) >= 0)?true:false))
      let ispermission =false

      author.map((x)=>{
        if(x==user.id){
          ispermission=true
        }
      })
      return (article.status =='Draft' || article.status =='Rejected') && ( article.history.createdId == user.id || ispermission)
    }

 }


 check_permission_reviewer(article,user){

  if(article!=undefined){

   let approver = (article.approver !=undefined)?article.approver:[];

  //  return (article.status =='Pending' || article.status =='Rejected') && (approver.includes(user.id))
  // return (article.status =='Pending' || article.status =='Rejected') && (( approver.join().indexOf(user.id) >= 0)?true:false)
    let ispermission =false

    approver.map((x)=>{
      if(x==user.id){
        ispermission=true
      }
    })

    return (article.status =='Pending' || article.status =='Rejected') && ispermission
  }

 }

 check_permission_coauthor(article,user){

  if(article!=undefined){

   let coauthor = (article.coauthor !=undefined)?article.coauthor:[];

  //  return (article.status =='Pending' || article.status =='Rejected') && (approver.includes(user.id))
  // return (article.status =='Draft' || article.status =='Rejected') && (( coauthor.join().indexOf(user.id) >= 0)?true:false)
      let ispermission =false

      coauthor.map((x)=>{
        if(x==user.id){
          ispermission=true
        }
      })

      return (article.status =='Draft' || article.status =='Rejected') && ispermission
  }

 }

 check_permission_admin(record,user){



  //  return  this.permissions.includes('manage_article') ;
  return ( this.permissions.join().indexOf('manage_article') >= 0)?true:false


  }

  check_permission_publisher(article,user){

    if(article!=undefined){

   let publisher = (article.publisher !=undefined)?article.publisher:[];


  //  return  (article.status =='Unpublished' || article.status =='Approved' || article.status =='Published' || article.status =='Rejected' ) && publisher.includes(user.id) ;

  // return  (article.status =='Unpublished' || article.status =='Approved' || article.status =='Published' || article.status =='Rejected' ) && (( publisher.join().indexOf(user.id) >= 0)?true:false) ;
        let ispermission =false

        publisher.map((x)=>{
          if(x==user.id){
            ispermission=true
          }
        })
        return  (article.status =='Unpublished' || article.status =='Approved' || article.status =='Published' || article.status =='Rejected' ) && ispermission;
    }

  }


  deleteReply(){

    let data={
      token:this.token,
      article:this.articleId,
      id:this.deleteReplyId,
      archive:true
    }
    this.articleService.commentSave(data).subscribe( (res)=>{

      if (res.status == 'success') {

        let data3={
          token:this.token,
          article:this.articleId
        }
        this.articleService.commentSave(data3).subscribe( (res)=>{

          if (res.status == 'success') {

            this.commentList = res.comment;
            this.offset = this.commentList.length;
            this.commentList.map((x,i)=>{

               if(x.commentAttachments){
                x['title']=[]
                x['toltipName']=[]
                 x['commentAttachmentsName']=[]
                 x.commentAttachments.map((y)=>{
                   let name=y.split('.').slice(1)
                   x.commentAttachmentsName.push(name[0])
                   let title = y.split('/').slice(2)
                   x.title.push(title[0])
                   let toltip = title[0].split('_');
                    toltip.shift();
                    let arr=[]
                    toltip.map((y)=>{
                      arr.push(y)
                    })
                    x.toltipName.push(arr.join('_'))
                 })
               }
               if(x.commentReply){
                x.commentReply.map((y)=>{
                  y.editMode = false;

                  if(y.commentAttachments){
                    y['title']=[]
                    y['toltipName']=[]
                    y['commentAttachmentsName']=[]
                    y.commentAttachments.map((z)=>{
                      let name=z.split('.').slice(1)
                      y.commentAttachmentsName.push(name[0])
                      let title = z.split('/').slice(2)
                      y.title.push(title[0])
                      let toltip = title[0].split('_');
                      toltip.shift();
                      let arr=[]
                      toltip.map((k)=>{
                        arr.push(k)
                      })
                      y.toltipName.push(arr.join('_'))
                    })
                  }

                })
              }
              if(x.status =='Private'){
                this.selectedType[i] = [{'key':'private','value':'Private'}]
              }else{
                this.selectedType[i] = [{'key':'public','value':'Public'}]
              }

            })
          }
        });

      }

    })


  }


  showMore(){

    let data3={
      token:this.token,
      article:this.articleId,
      offset:this.offset
    }
    this.articleService.commentSave(data3).subscribe( (res)=>{

      if (res.status == 'success' && res.comment.length>0) {

        this.commentList.push(res.comment);
        this.offset = this.commentList.length;
        this.commentList.map((x,i)=>{

           if(x.commentAttachments){
             x['commentAttachmentsName']=[]
             x['title']=[]
             x['toltipName']=[]
             x.commentAttachments.map((y)=>{
               let name=y.split('.').slice(1)
               x.commentAttachmentsName.push(name[0])
               let title = y.split('/').slice(2)
                x.title.push(title[0])
                let toltip = title[0].split('_');
                    toltip.shift();
                    let arr=[]
                    toltip.map((y)=>{
                      arr.push(y)
                    })
                    x.toltipName.push(arr.join('_'))
             })
           }
           if(x.commentReply){
            x.commentReply.map((y)=>{
              y.editMode = false;

              if(y.commentAttachments){
                y['title']=[]
                y['toltipName']=[]
                y['commentAttachmentsName']=[]
                y.commentAttachments.map((z)=>{
                  let name=z.split('.').slice(1)
                  y.commentAttachmentsName.push(name[0])
                  let title = z.split('/').slice(2)
                  y.title.push(title[0])
                  let toltip = title[0].split('_');
                    toltip.shift();
                    let arr=[]
                    toltip.map((k)=>{
                      arr.push(k)
                    })
                    y.toltipName.push(arr.join('_'))
                })
              }

            })
          }
          if(x.status =='Private'){
            this.selectedType[i] = [{'key':'private','value':'Private'}]
          }else{
            this.selectedType[i] = [{'key':'public','value':'Public'}]
          }

        })
      }
    });
  }

  archive_popup(id:number){

    this.deletecommentId = id;

    $('#success-popup').modal('show');


  }

  archive_replypopup(id:number){

    this.deleteReplyId = id;

    $('#reply-popup').modal('show');


  }

  onReplySelect(event:any){

  }


  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: true,
      idField: 'key',
      textField: 'value',
      closeDropDownOnSelection:true
    };


    if(this.commentId!=undefined){
      let id = this.commentId
      setTimeout(function(){
        const itemToScrollTo = document.getElementById('item-'+id);

        if (itemToScrollTo) {
          window.scrollTo(0, itemToScrollTo.offsetTop+100);
        }
      }, 1000);


    }else{
      window.scrollTo(0, 0);
    }

  }


  ngAfterViewInit(){


         $(function(){

            $('body').on('click','.editor-section a',function(e){

                e.preventDefault();



                window.open(
                   e.target.href, "_blank");


            });


         });

        
         window.onscroll = function (e) {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
            // console.log('scrollLeft',scrollTop,'window.innerHeight',window.innerHeight)
          }

          var popOverSettings2 = {
            placement: 'bottom',
            trigger : 'hover',
            container: 'body',
            html: true,
            selector: '[data-toggle="popover"]', //Sepcify the selector here
            content: function () {
     
              var content = '#share-details-info-'+$(this).attr("data-popover-content");
              
              return $(content).children(".popover-body").html();
      
      
            }
        }
       
        $('body').popover(popOverSettings2); 
        
      

        $('body').on('click','.share',function(event) {

          
          event.stopPropagation();
          $("#contributor_left_sidebar").addClass("menu-open")
          
  
           var $id = event.currentTarget.dataset.articleid;
  
  
             this.countributorArticleId = $id;
  
             this.showContributorLoadMore = true
  
             this.articleService.articleStatus({'token':this.token,'reqData':{'article':$id,'offset':0,status:['Shared','Contributed']}}).subscribe( (result)=>{
  
  
  
             if(result.status=='success'){
  
              let dups=[],arr=[]
              for(let i=0;i<result.workflow.length;i++){
                if (dups.indexOf(result.workflow[i].history.createdId) == -1) {
                      dups.push(result.workflow[i].history.createdId);
                      arr.push(result.workflow[i])
                    }
              }
              this.latestContributor= arr;
  
            if (!this.ref['destroyed']) {
              this.ref.detectChanges();
            }
  
  
  
  
  
             } else{
  
               this.latestContributor= [];
  
  
             }
  
            });
  
  
  
        }.bind(this));

        $("#msg-box-close2").click(function() {

          $("#contributor_left_sidebar").removeClass("menu-open")
         
  
        });
          

  }

  back(){ 

    let backurl;

    if(this.source){
      backurl = this.source
    }else{
      backurl = 'newsletter'
    }

    let data = backurl.split('-')
    
    if(data[0]=='home'){
      this.router.navigate(['/home']);
    }else if(data[0]=='article'){
      this.router.navigate(['/article']);
    }else if(data[0]=='search'){
      this.msg.sendMessage({'type':'search','details':this.searchTxt});
      if(this.category!=undefined && this.type!=undefined){
        this.router.navigate(['/search'],{ queryParams: { category: this.category,type:this.type } });
      }else if(this.category!=undefined){
        this.router.navigate(['/search'],{ queryParams: { category: this.category} });
      }else{
        this.router.navigate(['/search']);
      }
      
    }else if(data[0]=='newsletter' && data[1]!=undefined){ 

    this.router.navigate(['/newsletter/'+data[1]+'/view'],{ queryParams: { source: this.prevsource } });
      
    }else if(data[0]=='newsletter' && data[1]==undefined){
      this.router.navigate(['/newsletter/'+this.newsletterId+'/edit']);
    }else if(data[0]=='notification'){
      this.router.navigate(['/notification']);
    }
    
  }


  
  track(attach,source){
    
    let data={
      article:this.articleId,
      event:'download',
      source:'web',
      token:this.token
    }
    this.articleService.analytics(data).subscribe( (res)=>{

      if(res.status=='success' ){

      }
    })
    this.msg.sendMessage({type:'customeEvent',event:'attachment',value:attach,source:source,articleId:this.articleId});

  }

  trackTag(tag,source){

    this.msg.sendMessage({type:'customeEvent',event:'tag',value:tag,source:source,articleId:this.articleId});

  }

  viewArticle(id:number){
    
    this.loader_image =true
    window.scrollTo(0, 0);
   
    this.router.navigate(['/article/'+id+'/view'], { queryParams: { 'source':'article'} });
  }
  LoadMoreArticle(){

    event.stopPropagation();

    this.articleService.articleStatus({'token':this.token,'reqData':{'article':this.articleId,'offset':this.latestComments.length}}).subscribe( (result)=>{

      if(result.status=='success'){

        if(result.workflow.length>0){
          result.workflow.map((x)=>{
            this.latestComments.push(x)
          })

          if(result.workflow.length<5){
            this.showLoadMore = false
          }
          
        }else{
          this.showLoadMore = false
        }

      }
    })
   
    
  }
 

  LoadMoreContributorArticle(){

    event.stopPropagation();

    this.articleService.articleStatus({'token':this.token,'reqData':{'article':this.countributorArticleId,'offset':this.latestContributor.length,status:['Shared','Contributed']}}).subscribe( (result)=>{

      if(result.status=='success'){

        let dups=[],arr=[]
        for(let i=0;i<result.workflow.length;i++){
          if (dups.indexOf(result.workflow[i].history.createdId) == -1) {
                dups.push(result.workflow[i].history.createdId);
                arr.push(result.workflow[i])
              }
        }

        if(arr.length>0){
          arr.map((x)=>{
            this.latestContributor.push(x)
          })

          if(arr.length<5){
            this.showContributorLoadMore = false
          }
          
        }else{
          this.showContributorLoadMore = false
        }

      }
    })
   
    
  }

}
